import "../shared/components/modal.js";
import "../shared/utilities/form_validation.js";
import "../shared/utilities/form_review.js";
import "#vendor/jquery_plugins/jquery.mask.js";
import.meta.glob("./forms/*.{js,hbs,jst.ejs}", { eager: true });
import "#vendor/autosize.js";

window.Sparkle = window.Sparkle || {};

jQuery(document).ready(function () {
  var $form = jQuery(".form-builder-form");
  var formValidator = new FormValidation();
  var previewModal;

  jQuery(".date-mask").mask("09/09/0000");

  jQuery("[data-behaviour~=preview-form]").each(function () {
    var previewModalFooter = jQuery(
      "<input type='button' class='form-preview-button' data-behaviour='close-modal' value='Return to Form'></input>",
    );
    var previewHeader = jQuery(this).closest(".component").find("header").text() + " Preview";
    previewModal = new Modal({ header: previewHeader, footer: previewModalFooter, class: "preview-modal" });
  });

  // BEHAVIOUR
  jQuery("[data-behaviour~=preview-form]").on("click", openPreview);

  $form.on("submit", function (event) {
    var $button = $form.find(".submit");
    $button.attr("value", "Submitting...");
    return true;
  });

  // HTML5 VALIDATION
  jQuery("input[required]").on("blur", function () {
    jQuery(this).addClass("blurred");
    formValidator.addValidityMessage(this);
  });

  // Make sure invalid form doesn't submit in Safari
  if (typeof document.createElement("input").checkValidity === "function") {
    jQuery("form:not([novalidate])").on("submit", function (e) {
      if (!this.checkValidity()) {
        e.preventDefault();
      }
    });
  }
  jQuery("form:not([novalidate])").on("submit", handleSubmitAttempt);

  // REVEALING RADIO CONTENT
  jQuery(document).on("change", "[data-behavior=revealing-radio]", function () {
    if (jQuery(this).is(":checked")) {
      jQuery(
        "[data-behavior=revealing-radio-content][data-revealing-group=" + jQuery(this).data("revealing-group") + "]",
      ).hide();
      jQuery("#" + jQuery(this).attr("id") + "_revealing_content").show();
    }
  });
  jQuery("[data-behavior=revealing-radio]:checked").trigger("change");

  const handleDocumentChange = _.debounce(() => {
    jQuery(this).closest("form").trigger("submit");
  });

  // SUBMIT ON CHANGE
  jQuery(document).on("change", '[data-behaviour~="submit-on-change"]', handleDocumentChange);

  // HELPERS

  function handleSubmitAttempt() {
    var formElement = jQuery(this).closest("form");
    formElement.addClass("submit-attempted");
    formValidator.validateRequiredInputs(formElement);
  }

  function openPreview() {
    var formReview = new FormReview({ title: "" });
    var formElement = jQuery(this).closest("form");
    // add validation messages before cloning
    formValidator.validateInputs(formElement);

    // Store all input values before cloning since clone() doesn't retain the values of textareas and selects
    // After cloning, stick the stored value back into input.val() so the preview displays correctly

    var formFields = formElement.find(".form-fields");

    formReview.addReviewItem(formFields);
    previewModal.setBody(formReview.el);
    previewModal.show();
  }
});
